import React from 'react';
import {
    PlaceholderText
} from 'sarsaparilla';

export function FacilityPageHeaderPlaceholder() {
    return (
        <div>
            <PlaceholderText lines={1} lineHeight={36} fontSize={30} />
            <div className="mt-1 mb-1">
                <PlaceholderText lines={1} lineHeight={20} fontSize={12} width="170px" />
            </div>
        </div>
    );
}
